export default __webpack_public_path__ + "static/media/pec5.1382fead.jpg";